// GENERADO — no editar a mano. Origen: backend/src/oficina/compartido/.
// Regenerar: node scripts/gen-oficina-compartido.mjs

// Mesas de una sala. Código PURO y sin imports: lo usan el servidor (validar «mover», contratar) y la web (dibujar), así
// los dos cuentan las mismas mesas. Se copia a la web con scripts/gen-oficina-compartido.mjs.
//
// Mesas automáticas (Pau aprobó el 04-11, web/qa/auditoria-apple/plan.md «Lo que decide Pau» 2 y orden.md reglas 4 y 15):
// cada sala tiene SIEMPRE su gente + 1 mesa libre, numeradas 0..total-1 en orden de lectura. Sin tope: la sala crece en
// islas (contratar nunca da «sala llena»). Mover de mesa y «Ordenar» se quedan y no cambian el número de mesas.
// Antes (09-10, Pau: «añadir o quitar mesas como yo quiera») había «poner/quitar mesa» a mano, que congelaba el número
// (`mesas_fijadas`, `huecos_json`): dejó 6 mesas vacías en Venuz para 8 personas. Esas columnas siguen en la base (la
// migración 084 no se deshace) pero ya no se leen ni se escriben.

/** Cuántas mesas tiene la sala, dadas las mesas ocupadas: la gente + 1 libre, y nunca por debajo de la última ocupada. */
export function totalPuestos(ocupadas: readonly number[]): number {
  const mayor = ocupadas.reduce((m, x) => Math.max(m, x), -1);
  // Si hay un hueco por debajo de la última ocupada (alguien se fue), ese hueco ya es la mesa libre.
  return Math.max(mayor + 1, ocupadas.length + 1);
}

/** Primera mesa libre en orden de lectura (donde se sienta quien llega): siempre existe. */
export function primeraMesaLibre(ocupadas: readonly number[]): number {
  const ocupada = new Set(ocupadas);
  let m = 0;
  while (ocupada.has(m)) m += 1;
  return m;
}

// Grupos de mesas (04-11, «mesas de equipo», web/qa/auditoria-apple/propuesta-2/fuentes/grupos.md reglas 4-6): `mesa` es
// el sitio DENTRO de su grupo, y cada grupo cuenta sus mesas por su cuenta. «Sin grupo» sigue con la regla de siempre
// (`totalPuestos`: su gente + 1 libre). Un grupo con nombre NO lleva mesa libre fija (el «+» sale al pasar el ratón por su
// cartel): tiene justo hasta su última ocupada. Si alguien se va, su sitio queda vacío (la silueta) y es lo primero que
// ocupa el siguiente que entre (`primeraMesaLibre`); si se vacía la última fila, la isla se encoge por el final.

/** Mesas que se dibujan en un grupo con nombre: hasta su última ocupada (0 si no queda nadie: el grupo no se pinta). */
export function puestosDeGrupo(ocupadas: readonly number[]): number {
  return ocupadas.reduce((m, x) => Math.max(m, x), -1) + 1;
}

/**
 * ¿Se puede sentar a alguien en esa mesa del grupo? En «Sin grupo», hasta su mesa libre; en un grupo con nombre, también
 * en la mesa justo detrás de la última (el grupo crece en uno), nunca más allá: no quedan huecos sueltos al final.
 */
export function mesaValida(ocupadas: readonly number[], mesa: number, conNombre: boolean): boolean {
  return Number.isInteger(mesa) && mesa >= 0 && mesa < (conNombre ? puestosDeGrupo(ocupadas) + 1 : totalPuestos(ocupadas));
}
